import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type ToastTone = "success" | "error" | "warning" | "info";

export interface ToastItem {
  id: string;
  tone: ToastTone;
  title: string;
  description?: string;
  duration?: number;
}

export type CommandTab = "bookings" | "calendar" | "agencies" | "tickets" | null;

export interface UiState {
  toasts: ToastItem[];
  activeCommandTab: CommandTab;
  detailDrawerHotelId?: string;
}

const initialState: UiState = {
  toasts: [],
  activeCommandTab: null,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    pushToast: {
      reducer(state, action: PayloadAction<ToastItem>) {
        state.toasts.push(action.payload);
      },
      prepare(payload: Omit<ToastItem, "id">) {
        return { payload: { ...payload, id: crypto.randomUUID() } };
      },
    },
    dismissToast(state, action: PayloadAction<string>) {
      state.toasts = state.toasts.filter((t) => t.id !== action.payload);
    },
    setActiveCommandTab(state, action: PayloadAction<CommandTab>) {
      state.activeCommandTab = action.payload;
    },
    openHotelDrawer(state, action: PayloadAction<string>) {
      state.detailDrawerHotelId = action.payload;
    },
    closeHotelDrawer(state) {
      state.detailDrawerHotelId = undefined;
    },
  },
});

export const {
  pushToast,
  dismissToast,
  setActiveCommandTab,
  openHotelDrawer,
  closeHotelDrawer,
} = uiSlice.actions;

export default uiSlice.reducer;
